import { render, staticRenderFns } from "./MassiveStatusChangePage.vue?vue&type=template&id=1bc3ae43&"
import script from "./MassiveStatusChangePage.vue?vue&type=script&lang=js&"
export * from "./MassiveStatusChangePage.vue?vue&type=script&lang=js&"
import style0 from "./MassiveStatusChangePage.vue?vue&type=style&index=0&id=1bc3ae43&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports